module.exports = __webpack_public_path__ + "static/media/bg.2a04efdd.png";